import { render, staticRenderFns } from "./DoccurateItemToPalletCarton.vue?vue&type=template&id=4cd91371&"
import script from "./DoccurateItemToPalletCarton.vue?vue&type=script&lang=js&"
export * from "./DoccurateItemToPalletCarton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports